import {
    FETCH_ADDRESSES,
    FETCH_ADDRESSES_SUCCESS,
    FETCH_ADDRESSES_FAILED,
    EDIT_ADDRESS
  } from "../store/types";
  import store from '../store/store';
  import { firebase } from '../config/configureFirebase';
  import { onValue, remove, push, off } from "firebase/database";
  
  const loadAddressesViaRest = async (uid, dispatch) => {
    try {
      const { getValidAuthToken } = require("./authactions");
      let token = await getValidAuthToken();
      if (!token) return false;
      const baseUrl = (firebase.config?.databaseURL || "https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app").replace(/\/$/, '');
      let rtdbUrl = `${baseUrl}/savedAddresses/${uid}.json?auth=${token}`;
      let res = await fetch(rtdbUrl);
      if (res.status === 401) {
        token = await getValidAuthToken(true);
        if (token) {
          rtdbUrl = `${baseUrl}/savedAddresses/${uid}.json?auth=${token}`;
          res = await fetch(rtdbUrl);
        }
      }
      if (res.ok) {
        const data = await res.json();
        if (data && typeof data === 'object') {
          const arr = Object.keys(data).map(i => {
            data[i].id = i;
            return data[i];
          });
          dispatch({
            type: FETCH_ADDRESSES_SUCCESS,
            payload: arr
          });
          return true;
        } else {
          dispatch({
            type: FETCH_ADDRESSES_SUCCESS,
            payload: []
          });
          return true;
        }
      }
    } catch (e) {
      console.warn('[ADDRESS] REST fetch error:', e?.message);
    }
    return false;
  };

  export const fetchAddresses = () => (dispatch, getState) => {
    const {
      addressEditRef
    } = firebase;
    dispatch({
      type: FETCH_ADDRESSES,
      payload: null
    });
    const state = typeof getState === 'function' ? getState() : (store ? store.getState() : {});
    const authState = state?.auth;
    const currentUid = authState?.profile?.uid || authState?.info?.profile?.uid || firebase?.auth?.currentUser?.uid;
    if (!currentUid || !addressEditRef) {
      return;
    }

    // Immediate REST load for quick availability without WebSocket delay
    loadAddressesViaRest(currentUid, dispatch);

    try {
      off(addressEditRef(currentUid));
      onValue(addressEditRef(currentUid), snapshot => {
        if (snapshot.val()) {
          let data = snapshot.val();
          const arr = Object.keys(data).map(i => {
            data[i].id = i;
            return data[i];
          });
          dispatch({
            type: FETCH_ADDRESSES_SUCCESS,
            payload: arr
          });
        } else {
          dispatch({
            type: FETCH_ADDRESSES_SUCCESS,
            payload: []
          });
        }
      }, async (error) => {
        console.warn('[ADDRESS] onValue warn (retrying via REST):', error?.message);
        const ok = await loadAddressesViaRest(currentUid, dispatch);
        if (!ok) {
          dispatch({
            type: FETCH_ADDRESSES_FAILED,
            payload: error?.message || 'Error fetching addresses'
          });
        }
      });
    } catch (err) {
      console.warn('[ADDRESS] attach listener error:', err?.message);
      loadAddressesViaRest(currentUid, dispatch);
    }
  };
  
  const editAddressViaRest = async (targetUid, address, method) => {
    try {
      const { getValidAuthToken } = require("./authactions");
      let token = await getValidAuthToken();
      if (!token) return false;
      const baseUrl = (firebase.config?.databaseURL || "https://drive2go-c806b-default-rtdb.europe-west1.firebasedatabase.app").replace(/\/$/, '');
      
      if (method === 'Add') {
        let rtdbUrl = `${baseUrl}/savedAddresses/${targetUid}.json?auth=${token}`;
        let res = await fetch(rtdbUrl, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(address)
        });
        if (res.status === 401) {
          token = await getValidAuthToken(true);
          if (token) {
            rtdbUrl = `${baseUrl}/savedAddresses/${targetUid}.json?auth=${token}`;
            res = await fetch(rtdbUrl, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(address)
            });
          }
        }
        return res.ok;
      } else if (method === 'Delete') {
        let rtdbUrl = `${baseUrl}/savedAddresses/${targetUid}/${address.id}.json?auth=${token}`;
        let res = await fetch(rtdbUrl, {
          method: "DELETE"
        });
        if (res.status === 401) {
          token = await getValidAuthToken(true);
          if (token) {
            rtdbUrl = `${baseUrl}/savedAddresses/${targetUid}/${address.id}.json?auth=${token}`;
            res = await fetch(rtdbUrl, {
              method: "DELETE"
            });
          }
        }
        return res.ok;
      }
    } catch (e) {
      console.warn('[ADDRESS] editAddressViaRest error:', e?.message);
    }
    return false;
  };

  export const editAddress = (uid, address, method) => async (dispatch, getState) => {
    const {
      addressRef, 
      addressEditRef,
    } = firebase;
    dispatch({
      type: EDIT_ADDRESS,
      payload: { method, address }
    });
    try {
      const state = typeof getState === 'function' ? getState() : (store ? store.getState() : {});
      const targetUid = uid || state?.auth?.profile?.uid || state?.auth?.info?.profile?.uid || firebase?.auth?.currentUser?.uid;
      if (!targetUid) {
        throw new Error("User ID is missing");
      }
      
      let saved = false;
      try {
        if (method === 'Add') {
          await push(addressEditRef(targetUid), address);
        } else if (method === 'Delete') {
          await remove(addressRef(targetUid, address.id));
        }
        saved = true;
      } catch (wsErr) {
        console.warn('[ADDRESS] WebSocket edit failed, attempting REST fallback:', wsErr?.message);
        saved = await editAddressViaRest(targetUid, address, method);
        if (!saved) {
          throw wsErr;
        }
      }

      dispatch(fetchAddresses());
    } catch (error) {
      console.warn('[ADDRESS] editAddress error:', error?.message);
      dispatch({
        type: FETCH_ADDRESSES_FAILED,
        payload: error.message
      });
    }
  };